export default {
  baseURL: "https://xalix.cyou",
};
